/**
 * @class Scroll
 */
class Scroll {

    /**
     * @param {jQuery} $element
     * @param {String} speed
     * @returns {Scroll}
     */
    static to($element, speed = 'fast') {
        $element.animate({ scrollTop: 0 }, speed);
        return this;
    }
}

export default Scroll;